<div class="row" style="margin-left: 0px;margin-right: 0px;">


    <div class="col-md-12">
      <h4 class="title">Collateral Details</h4>

      <div class="card-box">
        <div class="row" style="padding: 0px 0px 23px 10px;">
          <div class="col-md-4">
            <h5 class="form-lable">Collateral Code:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-4">
            <h5 class="form-lable">Collateral Type:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-4">
            <h5 class="form-lable">Collateral Value:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-4">
            <h5 class="form-lable">CCY:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-4">
            <h5 class="form-lable">Expiry Date:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-4">
            <h5 class="form-lable">Sol ID:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-4">
            <h5 class="form-lable">%:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-4">
            <h5 class="form-lable">Opening/Creation Date:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-4">
            <h5 class="form-lable">Deposit A/c. ID:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-4">
            <h5 class="form-lable">Retail Loan / Credit Card Number:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-4">
            <h5 class="form-lable">CIF ID/Guarantor CIF:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <!-- <div class="col-md-12 mt-20">
                <button type="button" class="btn btn-primary">Add</button>
           </div> -->
      
        </div>
      </div>
    </div>
    <div class="doc-table">
      <div class="card-box"> <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt [paginator]="false" [rows]="5"
        [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [globalFilterFields]="['type']">
    
        <ng-template pTemplate="header">
          <tr style="text-align: center;">
            <th>Collateral Code</th>
            <th>Collateral Type</th>
            <th>Collateral Value</th>
            <th>CCY</th>
            <th>Expiry Date</th>
            <th>Sol ID</th>
            <th>%</th>
            <th>Opening/Creation Date</th>
            <th>Deposit A/c. ID</th>
            <th>Retail Loan / Credit Card Number</th>
            <th>CIF ID/Guarantor CIF</th>
          </tr>
          <tr style="text-align: center;">
            <td>  </td>
            <td>  </td>
            <td>  </td>
            <td>  </td>
            <td>  </td>
            <td>  </td>
            <td>  </td>
            <td>  </td>
            <td>  </td>
            <td>  </td>
            <td>  </td>
          </tr>
        </ng-template>
       </p-table>  </div>
    </div>
    <br>
    </div>